import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CustomerService } from '../customer.service';
import { FormBuilder, NgForm } from '@angular/forms';
import { Subject, Subscription } from 'rxjs/Rx';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Location } from '@angular/common';
import { EvsStampService } from '../../../../../common/services/EvsStamp.service';
import { PagerService } from '../../../../../common/services/Pagination.service';
import { ModalInfoService } from '../../../../../common/services/ModalInfo.service';
import { EvsAddressService } from '../../../../../common/services/EvsAddress.service';
import { ConfirmationService } from 'primeng/primeng';
import { Message } from 'primeng/components/common/message';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { environment } from '../../../../../../environments/environment';
import { ImageService } from '../../../../imageService';
import { PromotionService } from '../../../../../common/services/Promotion.service';
import { saveAs } from 'file-saver/FileSaver';
import * as moment from 'moment';
import { UploadService } from '../../../../../common/services/Upload.service';
import { ExportService } from '../../../../../common/services/Export.service';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;

@Component({
  selector: 'app-list',
  templateUrl: './list-detail.component.html',
  styleUrls: ['./list-detail.component.css'],
  providers: [
    ConfirmationService,
    EvsAddressService,
    EvsStampService,
    PromotionService,
  ],
})
export class ListComponent implements OnInit, OnDestroy {
  modalRef: BsModalRef;
  @ViewChild('importListClient') importListClient: ModalDirective;
  @ViewChild('confirmOveride') confirmOveride: ModalDirective;
  public dtOptions: any = {};
  public dtTrigger: Subject<any> = new Subject();
  public currentPage = 1;
  public totalRow = 0;
  public page_size = 10;
  public offset = 0;
  public pager: any = {};
  public dataCustomer: any = [];
  public message: { class: string; content: string } = null;
  public error = '';
  public componentData = null;
  public routerChange: any;
  public model: any = {};
  public paramsQuery: any = {};
  public cities: Array<any> = [];
  public districts: Array<any> = [];
  public msgs: Message[] = [];
  public modalRef2: any;

  stamp_types: any = [
    {
      type: 'static',
      title: 'Tem marketing',
    },
    {
      type: 'dynamic',
      title: 'Tem xác thực',
    },
  ];

  listStatus: any = [];

  public current_filter: any = {};
  public item_active: any = 0;
  public item_detail: any = {};
  loading_data = true;
  guarantees: any = [];
  guaranteeCurentpage = 1;
  public guaranteePage_size = 3;
  historyOfcares: any = [];
  historyOfcareCurentpage = 1;
  public historyOfcarePage_size = 3;
  isSorting: any;
  isUpdate: Boolean = false;

  statusModel: any;

  statusCreateModel: any = null;
  noteCreateModel: any;
  vendorDetail: any = {};

  totalItem: any = {
    count: 0,
    count_not_yet: 0,
    count_doing: 0,
    count_have_been: 0,
  };
  totalPage: any = 0;

  totalGuaranteeItem: any = 0;
  totalGuaranteePage: any = 0;

  totalHistoryOfCareItem: any = 0;
  totalHistoryOfCarePage: any = 0;

  no_product = 'assets/images/no_product.png';
  no_image = 'assets/images/no-image.png';
  imagesFields: any = {};
  cusomerUpdate: any = {
    city: 0,
    district: 0,
  };
  districtsUpdate: any = [];
  isChangeStatus: Boolean = false;
  itemStatus: any;
  subcribe: Subscription = null;
  private langSub: Subscription = null;
  public gifts: any = [];
  public totalItem2 = 0;
  public totalPage2 = 0;
  public currentPage2: any = 1;
  public staticStamp: any = {};
  public static_stamp_id: number;

  /**[27/10/2022]- Tuanba: Export danh sách khách hàng**/
  public pageSizeStampVerify = 10;
  public pageIndexStampVerify = 1;
  public totalStampVerify = 0;
  public dataStampVerify = [];
  public code_chonggia = 1;
  public code_baohanh = 2;
  public code_tranhang = 3;
  public code_dinhdanh = 5;
  public fieldExportCustomer: any;
  public messageExport: any;
  /** Tuanba:13-11-2023: Hiện thị phường xã cho doanh nghiệp Darling **/
  public checkWard: any;

  constructor(
    private _location: Location,
    private service: CustomerService,
    private pagerService: PagerService,
    private router: Router,
    public addressService: EvsAddressService,
    private confirmationService: ConfirmationService,
    private mdInfo: ModalInfoService,
    private activatedRoute: ActivatedRoute,
    private _fb: FormBuilder,
    private toastr: ToastrService,
    private evsStampService: EvsStampService,
    private modalService: BsModalService,
    private imageService: ImageService,
    private upload: UploadService,
    private promotionService: PromotionService,
    private exportService: ExportService,
    private translate: TranslateService
  ) {
    this.item_detail = undefined;
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params.static_stamp_id) {
        this.static_stamp_id = params.static_stamp_id;
      }
    });
  }

  //Tuanba:6/4/2021: Import file khách hàng
  public titleFile = '';

  ngOnDestroy() {
    if (this.subcribe) {
      this.subcribe.unsubscribe();
    }
    if (this.langSub) {
      this.langSub.unsubscribe();
    }
  }

  deleteImageFields(id, fieldKey) {
    for (let i = 0; i < this.imagesFields[fieldKey].length; i++) {
      if (this.imagesFields[fieldKey][i].id === id) {
        this.imagesFields[fieldKey].splice(this.imagesFields[fieldKey].indexOf(this.imagesFields[fieldKey][i]), 1);
        break;
      }
    }
  }

  tusUploadFields = (item, fieldKey) => {
    const numberImages = item.target.files.length;
    if (numberImages > 5) {
      this.toastr.error('Chỉ được upload tối đa 5 ảnh', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      for (const image of item.target.files) {
        const fileData = new FormData();
        // @ts-ignore
        fileData.append('file', image);
        return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
          const res = JSON.parse(response._body)
          if (res.status === 200) {
            const image2 = res.data.url;
            if (this.imagesFields[fieldKey].length >= 5) {
              this.toastr.error('Chỉ được upload tối đa 5 ảnh', '', {
                timeOut: 4000,
                positionClass: 'toast-bottom-right',
              });
            } else {
              this.imagesFields[fieldKey].push(image2);
            }
          }
        });


      }
    }
  };

  ngOnInit() {
    this.titleFile = this.translate.instant('PS_CHON_FILE_UPLOAD');
    const user = JSON.parse(localStorage.getItem('User'));
    const wardBussiness = environment.wardBussiness
    if (user) {
      this.checkWard = wardBussiness.includes(user.id)
    }
    const that = this;
    $('#status').select2({
      placeholder: this.translate.instant('TRANG_THAI_LABEL'),
      allowClear: false,
    });
    const province = $('#province');
    const district = $('#district');
    const stampType = $('#stamp_type');
    province.select2({ placeholder: this.translate.instant('TINH_THANH'), allowClear: false });
    district.select2({ placeholder: this.translate.instant('QUAN_HUYEN_LABEL'), allowClear: false });
    stampType.select2({
      placeholder: this.translate.instant('NGUON_KHACH_HANG'),
      allowClear: false,
    });
    this.listStatus = [
      {
        status: 'NotYet',
        title: this.translate.instant('CHUA_CHAM_SOC'),
        description: this.translate.instant('CHUA_CHAM_SOC'),
      },
      {
        status: 'Doing',
        title: this.translate.instant('DANG_CHAM_SOC'),
        description: this.translate.instant('DANG_CHAM_SOC'),
      },
      {
        status: 'HaveBeen',
        title: this.translate.instant('DA_CHAM_SOC'),
        description: this.translate.instant('DA_CHAM_SOC'),
      },
    ];

    this.langSub = this.translate.onLangChange.subscribe(() => {
      this.listStatus = [
        {
          status: 'NotYet',
          title: this.translate.instant('CHUA_CHAM_SOC'),
          description: this.translate.instant('CHUA_CHAM_SOC'),
        },
        {
          status: 'Doing',
          title: this.translate.instant('DANG_CHAM_SOC'),
          description: this.translate.instant('DANG_CHAM_SOC'),
        },
        {
          status: 'HaveBeen',
          title: this.translate.instant('DA_CHAM_SOC'),
          description: this.translate.instant('DA_CHAM_SOC'),
        },
      ];
      $('#status').select2({
        placeholder: this.translate.instant('TRANG_THAI_LABEL'),
        allowClear: false,
      });
      province.select2({ placeholder: this.translate.instant('TINH_THANH'), allowClear: false });
      district.select2({ placeholder: this.translate.instant('QUAN_HUYEN_LABEL'), allowClear: false });
      stampType.select2({
        placeholder: this.translate.instant('NGUON_KHACH_HANG'),
        allowClear: false,
      });
      if (!this.files || this.files.length === 0) {
        this.titleFile = this.translate.instant('PS_CHON_FILE_UPLOAD');
      }
    });
    province.on('select2:select', function (e) {
      $('.select2-selection__rendered').removeAttr('title');
      const id = e.target.value;
      that.loadDistrictData(id);
    });
    district.on('select2:select', function () {
      $('.select2-selection__rendered').removeAttr('title');
    });
    // this.clearDataForm();
    this.getCity();
    this.isSorting = 'desc';
    this.subcribe = this.modalService.onHide.subscribe(() => {
      if (this.isChangeStatus == true) {
        this.viewDetail(this.item_active, this.dataCustomer[this.item_active]);
        this.dataCustomer[
          this.item_active
        ].status.status = this.statusCreateModel;
        switch (this.statusCreateModel) {
          case 'NotYet': {
            this.dataCustomer[this.item_active].status.title = this.translate.instant('CHUA_CHAM_SOC');
            break;
          }
          case 'Doing': {
            this.dataCustomer[this.item_active].status.title = this.translate.instant('DANG_CHAM_SOC');
            break;
          }
          case 'HaveBeen': {
            this.dataCustomer[this.item_active].status.title = this.translate.instant('DA_CHAM_SOC');
            break;
          }
        }
        this.isChangeStatus = false;
      } else {
        this.loadData(this.current_filter, this.isSorting);
      }
    });

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.isSorting = 'desc';
      if (params.customer_name) {
        this.current_filter.name = params.customer_name;
        $('#name').val(params.batch_id).trigger('change');
        this.loadData(this.current_filter, this.isSorting);
      } else {
        this.loadData(this.current_filter, this.isSorting);
      }
    });
  }

  getCity() {
    this.addressService.getCities().subscribe((res) => {
      const citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.cities = citiesList;

      this.setSort('desc');
    });
  }

  filterClick(type, frm: NgForm) {
    switch (type) {
      case 'count_customer': {
        $('#status').val('').trigger('change');
        $('#province').val('').trigger('change');
        $('#district').val('').trigger('change');
        frm.reset();
        this.getData();
        break;
      }
      case 'count_not_yet': {
        $('#status').val('NotYet').trigger('change');
        $('#province').val('').trigger('change');
        $('#district').val('').trigger('change');
        frm.reset();
        this.getData();
        break;
      }
      case 'count_doing': {
        $('#status').val('Doing').trigger('change');
        $('#province').val('').trigger('change');
        $('#district').val('').trigger('change');
        frm.reset();
        this.getData();
        break;
      }
      case 'count_have_been': {
        $('#status').val('HaveBeen').trigger('change');
        $('#province').val('').trigger('change');
        $('#district').val('').trigger('change');
        frm.reset();
        this.getData();
        break;
      }
    }
  }


  loadStaticStamp(static_stamp_id) {
    this.evsStampService
      .findStaticStampById(static_stamp_id)
      .subscribe((res: any) => {
        this.staticStamp = res.data || {};
        console.log(this.staticStamp);
      });
  }

  loadDistrictData(id: number) {
    this.addressService
      .getDistrict({ city_id: id })
      .toPromise()
      .then((res) => {
        const districts = [];
        res.data.districts.forEach((c: any) => {
          districts.push({
            value: c.name,
            label: c.name,
            id: c.id,
          });
        });
        this.districts = districts;
      });
  }

  loadGuarantee() {
    //this.guarantees = [];
    const request = {};
    $('#inputGuaranteePage').val(this.guaranteeCurentpage);
    request['offset'] =
      this.guaranteePage_size *
      (this.guaranteeCurentpage <= 0 ? 0 : this.guaranteeCurentpage - 1);
    request['limit'] = this.guaranteePage_size;
    request['sort_by'] = 'created_time:desc';
    this.evsStampService
      .getDetailtLogGuaranteeByPhone(this.item_detail.id, request)
      .subscribe((resLog: any) => {
        this.guarantees = resLog.data.guarantee_logs;
        this.totalGuaranteeItem = resLog.data.count;
        const pageString = (
          this.totalGuaranteeItem / this.guaranteePage_size
        ).toString();
        const pageSplit = pageString.split('.');
        let last: any;
        let totalpage = parseInt(pageSplit[0]);
        if (pageSplit.length > 1) {
          last = pageSplit[1];
          if (parseInt(last) > 0) {
            totalpage++;
          }
        }
        this.totalGuaranteePage = totalpage;
        if (this.guarantees.length > 0) {
          for (let i = 0; i < this.guarantees.length; i++) {
            if (this.guarantees[i].product) {
              this.guarantees[i].product.image = this.imageService.readSrcImage(
                this.guarantees[i].product.image,
                'thumb_small'
              );
            }
            for (let c = 0; c < this.cities.length; c++) {
              if (this.guarantees[i].store) {
                if (this.guarantees[i].store.province == this.cities[c].id) {
                  this.guarantees[i].store.province = this.cities[c].value;
                  this.addressService
                    .getDistrict({ city_id: this.cities[c].id })
                    .toPromise()
                    .then((resDistrict) => {
                      const districts = resDistrict.data.districts;
                      for (let d = 0; d < districts.length; d++) {
                        if (
                          this.guarantees[i].store.district == districts[d].id
                        ) {
                          this.guarantees[i].store.district = districts[d].name;
                        }
                      }
                    });
                }
              }
            }

            if (this.guarantees[i].prefix && this.guarantees[i].number) {
              const pad = '000000';
              const number = this.guarantees[i].number.toString();
              this.guarantees[i].serial =
                this.guarantees[i].prefix +
                '-' +
                pad.substring(0, 6 - number.length) +
                number;
            }
          }
        }
        //console.log(this.guarantees)
      });
  }

  onSubmit() {
    this.item_active = 0;
    this.getData();
  }

  loadHistoryOfCare() {
    //this.historyOfcares = [];
    const request = {};
    $('#inputHistoryOfCarePage').val(this.historyOfcareCurentpage);
    request['offset'] =
      this.historyOfcarePage_size *
      (this.historyOfcareCurentpage <= 0
        ? 0
        : this.historyOfcareCurentpage - 1);
    request['limit'] = this.historyOfcarePage_size;
    request['sort_by'] = 'created_time:desc';
    this.evsStampService
      .getHistoryOfCare(this.item_detail.phone, request)
      .subscribe((res) => {
        this.totalHistoryOfCareItem = res.data.count.count;
        const pageString = (
          this.totalHistoryOfCareItem / this.historyOfcarePage_size
        ).toString();
        const pageSplit = pageString.split('.');
        let last: any;
        let totalpage = parseInt(pageSplit[0]);
        if (pageSplit.length > 1) {
          last = pageSplit[1];
          if (parseInt(last) > 0) {
            totalpage++;
          }
        }
        this.totalHistoryOfCarePage = totalpage;

        if (res.data.history_of_care.length > 0) {
          this.historyOfcares = res.data.history_of_care;
          this.statusModel = this.historyOfcares[0].status;
        } else {
          this.statusModel = 'NotYet';
        }
      });
  }

  resetForm(frm: NgForm) {
    $('#status').val('').trigger('change');
    $('#province').val('').trigger('change');
    $('#district').val('').trigger('change');
    $('#stamp_type').val('').trigger('change');
    frm.reset();
    this.getData();
  }

  search(event, mode?: any) {
    switch (mode) {
      case 'name':
        this.model.name = event;
        break;
      default:
        this.model.name = event;
        break;
    }
    this.router.navigate([], {
      queryParams: this.model,
    });
  }

  /* pagination */
  setPage(page: number) {
    // console.log("page",page);
    this.item_active = 0;
    if (this.totalPage <= 0) {
      this.toastr.warning('Không có dữ liệu khách hàng ', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      $('#inputPage').val(0);
    } else {
      if (page <= this.totalPage) {
        if (page < 1) {
          page = 1;
        } else if (page > this.totalPage) {
          page = this.totalPage;
        }
        //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page != this.currentPage) {
          this.currentPage = page;
          this.loadData(this.current_filter, this.isSorting);
        }
      } else {
        page = this.totalPage;
        $('#inputPage').val(page);
        this.toastr.warning(
          'Số trang khách hàng tối đa hiện tại là ' + page,
          '',
          {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          }
        );
        if (page < 1) {
          page = 1;
        } else if (page > this.totalPage) {
          page = this.totalPage;
        }
        //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page != this.currentPage) {
          this.currentPage = page;
          this.loadData(this.current_filter, this.isSorting);
        }
      }
    }
  }

  setGuaranteePage(page: number) {
    if (page <= this.totalGuaranteePage) {
      if (page < 1) {
        page = 1;
      } else if (page > this.totalGuaranteePage) {
        page = this.totalGuaranteePage;
      }
      //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
      if (page != this.guaranteeCurentpage) {
        this.guaranteeCurentpage = page;
        this.loadGuarantee();
      }
    } else {
      page = this.totalGuaranteePage;
      if (page <= 0) {
        this.toastr.warning('Không có dữ liệu lịch sử bảo hành ', '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        $('#inputGuaranteePage').val(1);
        this.guaranteeCurentpage = 1;
      } else {
        this.toastr.warning(
          'Số trang lịch sử bảo hành tối đa hiện tại là ' + page,
          '',
          {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          }
        );
        if (page < 1) {
          page = 1;
        } else if (page > this.totalGuaranteePage) {
          page = this.totalGuaranteePage;
        }
        $('#inputGuaranteePage').val(page);
        //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page != this.guaranteeCurentpage) {
          this.guaranteeCurentpage = page;
          this.loadGuarantee();
        }
      }
    }
  }

  historyOfCarePage(page: number) {
    if (this.totalHistoryOfCarePage <= 0) {
      this.toastr.warning('Không có dữ liệu lịch sử chăm sóc ', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      $('#inputHistoryOfCarePage').val(1);
      this.historyOfcareCurentpage = 1;
      //this.loadHistoryOfCare();
    } else {
      if (page <= this.totalHistoryOfCarePage) {
        if (page < 1) {
          page = 1;
        } else if (page > this.totalHistoryOfCarePage) {
          page = this.totalHistoryOfCarePage;
        }
        //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page != this.historyOfcareCurentpage) {
          this.historyOfcareCurentpage = page;
          this.loadHistoryOfCare();
        }
      } else {
        page = this.totalHistoryOfCarePage;
        if (page <= 0) {
          this.toastr.warning('Không có dữ liệu lịch sử chăm sóc ', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          $('#inputHistoryOfCarePage').val(1);
          this.historyOfcareCurentpage = 1;
        } else {
          this.toastr.warning(
            'Số trang lịch sử chăm sóc tối đa hiện tại là ' + page,
            '',
            {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            }
          );
          if (page < 1) {
            page = 1;
          } else if (page > this.totalHistoryOfCarePage) {
            page = this.totalHistoryOfCarePage;
          }
          $('#inputHistoryOfCarePage').val(page);
          //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
          if (page != this.historyOfcareCurentpage) {
            this.historyOfcareCurentpage = page;
            this.loadHistoryOfCare();
          }
        }
      }
    }
  }

  rowIndex(i: number) {
    if (this.currentPage == 1) {
      return i + 1;
    } else {
      return this.page_size * (this.currentPage - 1) + (i + 1); //currentPage start from: 0
    }
  }

  handleUpdated(event) {
    if (event) {
      this.loadData(this.paramsQuery, this.isSorting);
    }
  }

  backToComponent() {
    this._location.back();
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }

  goGuaranteePage2(toPage: any) {
    //console.log(toPage);
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setGuaranteePage(toPage);
    }
  }

  historyOfCarePage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.historyOfCarePage(toPage);
    }
  }

  setSort(typeSort: string) {
    this.isSorting = typeSort;
    this.loadData(null, typeSort);
  }

  backUpdateWork(event) {
    this.isUpdate = false;
    if ((event.isBack = false)) {
      this.setSort(this.isSorting);
    }
  }

  getData() {
    const modelQuery = <any>{};

    if (this.model.name) {
      modelQuery.name = this.model.name;
    }
    if (this.model.phone) {
      modelQuery.phone = this.model.phone;
    }
    if (this.model.email) {
      modelQuery.email = this.model.email;
    }
    const status = $('#status option:selected').val();
    if (status != '') {
      modelQuery.status = status;
    }
    const city = $('#province option:selected').val();
    if (city != '') {
      modelQuery.city = parseInt(city);
    }
    const district = $('#district option:selected').val();
    if (district != '') {
      modelQuery.district = parseInt(district);
    }

    const type = $('#stamp_type option:selected').val();
    if (type != '') {
      modelQuery.stamp_type = type;
    }
    const created_time_val = $('#created_time').val();
    if (created_time_val) {
      const listDate = created_time_val.toString().split(' - ');
      if (listDate.length > 1) {
        modelQuery.from_create = moment(listDate[0], 'DD/MM/YYYY').format('YYYY-MM-DD');
        modelQuery.to_create = moment(listDate[1], 'DD/MM/YYYY').format('YYYY-MM-DD');
      }
    }
    const care_time = $('#care_time').val();
    console.log('created_time_val', created_time_val, care_time)
    if (care_time) {
      const listDate = care_time.toString().split(' - ');
      if (listDate.length > 1) {
        modelQuery.from_time_of_care = moment(listDate[0], 'DD/MM/YYYY').format('YYYY-MM-DD');
        modelQuery.to_time_of_care = moment(listDate[1], 'DD/MM/YYYY').format('YYYY-MM-DD');
      }
    }
    console.log('modelQuery', modelQuery)

    this.currentPage = 1;
    this.current_filter = modelQuery;
    this.loadData(modelQuery, this.isSorting);
  }

  openModalUpdate(template: TemplateRef<any>, type: any) {
    this.statusCreateModel = type;
    this.noteCreateModel = '';
    this.modalRef = this.modalService.show(template);
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  gotoGuarantee(serial: any) {
    this.router.navigate(['/evs/guarantee/logs', { serial: serial }]);
  }

  listField;
  typeField = {};
  typeName = {};
  listRequire = [];

  updateStatus() {
    const data: any = {
      status: null,
      body: {
        note: null,
      },
    };
    data.status = this.statusCreateModel;
    data.body.note = this.noteCreateModel;
    if (!data.body.note) {
      switch (data.status) {
        case 'NotYet': {
          data.body.note = this.translate.instant('CHUA_CHAM_SOC');
          break;
        }
        case 'Doing': {
          data.body.note = this.translate.instant('DANG_CHAM_SOC');
          break;
        }
        case 'HaveBeen': {
          data.body.note = this.translate.instant('DA_CHAM_SOC');
          break;
        }
      }
    }
    this.evsStampService
      .updateCare(this.item_detail.phone, data)
      .toPromise()
      .then((res) => {
        if (res.error) {
          this.toastr.error(res.message, '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
        } else {
          this.toastr.success('Chuyển trạng thái thành công', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          this.isChangeStatus = true;
          this.modalRef.hide();
        }
      })
      .catch((err) => {
        this.toastr.error(err.message, '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      });
  }

  openUpdateCustomer(template: TemplateRef<any>) {
    this.viewDetail(this.item_active, this.dataCustomer[this.item_active]);
    this.modalRef = this.modalService.show(template);
    this.cusomerUpdate.name = this.item_detail.name;
    this.cusomerUpdate.phone = this.item_detail.phone;
    this.cusomerUpdate.email = this.item_detail.email;
    this.cusomerUpdate.address = this.item_detail.address;
    this.cusomerUpdate.city = this.item_detail.city;


    this.cusomerUpdate['nameField'] = {}
    this.cusomerUpdate['fields'] = {}
    this.evsStampService.getFieldGuaranteeCustomes().subscribe((res) => {
      if (res.data.length > 0) {
        this.listField = res.data;
        this.listField.map((val) => {
          this.typeField[val.key] = val.type
          this.typeName[val.key] = val.name
          if (val.require === 1) {
            this.listRequire.push(val.key)
          }
          this.cusomerUpdate['nameField'][val.key] = val.name

          console.log('this.item_detail111', this.item_detail)
          if (val.type === 'image') {
            this.imagesFields[val.key] = []
            this.cusomerUpdate['fields'][val.key] = []
            console.log('this.imagesFields', typeof this.imagesFields)
          }
          if (val.type === 'checkbox') {
            this.cusomerUpdate['fields'][val.key] = {}
            val.value_f.map((n) => {
              this.cusomerUpdate['fields'][val.key][`check${n.id}`] = false
            })
          }


          if (this.item_detail.fields && this.item_detail.fields.length > 0 && this.item_detail.fields !== null) {
            this.item_detail.fields.map((item) => {
              if (item.key === val.key) {

                if (val.type === 'date') {

                  this.cusomerUpdate['fields'][val.key] = moment(item.value).format('DD/MM/YYYY')
                } else if (val.type === 'checkbox') {
                  this.cusomerUpdate['fields'][val.key] = {}
                  // console.log('val.value_f', val.value_f)
                  val.value_f.map((n) => {
                    if (item.string_values.split(',').includes(String(n.id))) {
                      this.cusomerUpdate['fields'][val.key][`check${n.id}`] = String(n.id)
                    }
                  })
                  console.log('this.cusomerUpdate[\'fields\']', this.cusomerUpdate['fields'])
                } else if (val.type === 'image') {
                  this.imagesFields[val.key] = item.string_values === null ? [] : item.string_values
                } else {
                  this.cusomerUpdate['fields'][val.key] = item.string_values.value

                }
              }

            })
          }
        })
      }

    });

    this.loadDistrictUpdate(this.item_detail.district);
  }

  public files: any = null;
  public data_import_success: { class: string; content: string; } = null;
  public data_import_fail: { class: string; content: string; } = null;
  // tslint:disable-next-line:one-line

  // tslint:disable-next-line:one-line
  downloadExcelExample() {
    console.log('va', this.files2);
    this.service.downloadExcelExample().subscribe((res) => {
      saveAs(res, 'import_customer.xlsx')
      console.log(res)
    }, error => {
      this.toastr.warning(error, 'Thông báo', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      })
    })
  }

  openModalImportClient() {
    this.importListClient.show();
  }

  closeListClident() {
    this.importListClient.hide();
    this.message = null;
    this.clearInputFile();
  }

  openModalConfirmOveride() {
    this.confirmOveride.show();
  }

  closeListConfirmOveride() {
    this.confirmOveride.hide();
  }

  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  clearInputFile() {
    const input = $('#controlFile');
    input.wrap('<form>').closest('form').get(0).reset();
    input.unwrap();
  }

  public files2: any;

  onChange(event) {
    console.log('event', event)
    this.files = event.target.files;
    this.files2 = this.files[0];
    if (this.files.length > 0) {
      this.titleFile = this.files[0].name;
    } else {
      this.titleFile = this.translate.instant('PS_CHON_FILE_UPLOAD');
    }
  }

  submitFormConfirmExcel() {
    console.log(`12312312312312312388`);
    this.service.uploadFileCustomer(this.files2, '2').subscribe((res: any) => {
      if (res.code === 1) {
        this.closeListConfirmOveride();
        setTimeout(() => {
          this.pager = 1;
          this.loadData(this.paramsQuery, this.isSorting);
        }, 1000);
        this.files2 = null;
        this.clearInputFile()
        this.message = {
          class: 'alert dark alert-icon alert-success',
          content: this.translate.instant('NHAP_FILE_KHACH_HANG_THANH_CONG')
        }
      }
    }, (error) => {
      setTimeout(() => {
        this.pager = 1;
        this.loadData(this.paramsQuery, this.isSorting);
      }, 1000);
      this.clearInputFile()
      this.message = {
        class: 'alert dark alert-icon alert-danger',
        content: this.translate.instant('NHAP_FILE_KHACH_HANG_THAT_BAI')
      }
      this.files2 = null;
    })
  }

  submitFormRejectExcel() {
    this.service.uploadFileCustomer(this.files2, '1').subscribe((res: any) => {
      if (res.code === 1) {
        this.closeListConfirmOveride();
        setTimeout(() => {
          this.pager = 1;
          this.loadData(this.paramsQuery, this.isSorting);
        }, 1000);
        this.clearInputFile()
        this.files2 = null;
        this.message = {
          class: 'alert dark alert-icon alert-success',
          content: this.translate.instant('NHAP_FILE_KHACH_HANG_THANH_CONG')
        }
      }
    }, (error) => {
      setTimeout(() => {
        this.pager = 1;
        this.loadData(this.paramsQuery, this.isSorting);
      }, 1000);
      this.clearInputFile()
      this.message = {
        class: 'alert dark alert-icon alert-danger',
        content: this.translate.instant('NHAP_FILE_KHACH_HANG_THAT_BAI')
      }
    })
  }

  submitFormImportExcel() {
    this.message = null;
    this.data_import_success = null;
    this.data_import_fail = null
    this.titleFile = this.translate.instant('PS_CHON_FILE_UPLOAD');
    console.log('this.files ', this.files)
    console.log('this.files---2 ', this.files2)
    if (this.files !== null && this.files.length > 0) {
      const file = this.files[0];
      this.files = null;
      const file_name = file.name;
      const allowedExtensions = ['xlsx', 'xls', 'csv'];
      const fileExtension = file_name.split('.').pop();
      console.log('allowedExtensions', allowedExtensions)
      console.log('fileExtension', fileExtension)

      if (this.isInArray(allowedExtensions, fileExtension)) {
        //msg process
        this.message = {
          class: 'alert dark alert-success',
          content: this.translate.instant('SS_DANG_THUC_HIEN')
        };
        //upload file
        // let body = {
        //   file: file,
        //   type: "1"
        // }
        // console.log("bodyyyyy", body);

        this.service.uploadFileCustomer(file, '0').subscribe((res: any) => {
          if (res.code === 1) {
            this.message = {
              class: 'alert dark alert-icon alert-success',
              content: this.translate.instant('NHAP_FILE_KHACH_HANG_THANH_CONG'),
            };
            setTimeout(() => {
              this.pager = 1;
              this.loadData(this.paramsQuery, this.isSorting);
            }, 1000);
            this.files2 = null;
            this.clearInputFile()
          } else if (res.code === 1023) {
            this.openModalConfirmOveride();
            this.message = null;
          } else {
            this.message = {
              class: 'alert dark alert-icon alert-danger',
              content: res.message
            }
          }
        }, error => {
          this.message = {
            class: 'alert dark alert-icon alert-danger',
            content: error.message
          };
        });
      } else {
        this.message = {
          class: 'alert alert-danger',
          content: this.translate.instant('VUI_LONG_CHON_DUNG_FILE_EXCEL')
        };
      }
    } else {
      this.message = {
        class: 'alert alert-danger',
        content: this.translate.instant('BAN_CHUA_CHON_FILE_DE_IMPORT')
      };
    }
  }

  loadDistrictUpdate(id) {
    if (this.cusomerUpdate.city != 0) {
      this.addressService
        .getDistrict({ city_id: this.cusomerUpdate.city })
        .toPromise()
        .then((res) => {
          const districts = [];
          res.data.districts.forEach((c: any) => {
            districts.push({
              value: c.name,
              label: c.name,
              id: c.id,
            });
          });
          this.districtsUpdate = districts;
          if (id) {
            this.cusomerUpdate.district = id;
          } else {
            this.cusomerUpdate.district = this.districtsUpdate[0].id;
          }
        });
    }
  }

  updateCustomer() {
    const body: any = {};
    if (!this.cusomerUpdate.phone) {
      this.toastr.warning('Số điện thoại không được để trống', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      body.phone = this.cusomerUpdate.phone;
    }
    if (!this.cusomerUpdate.name) {
      this.toastr.warning('Tên khách hàng không được để trống', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      body.name = this.cusomerUpdate.name;
    }
    body.email = this.cusomerUpdate.email;
    body.address = this.cusomerUpdate.address;
    if (!this.cusomerUpdate.city || this.cusomerUpdate.city == 0) {
      this.toastr.warning('Phải chọn Tỉnh/Thành phố', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      body.city = this.cusomerUpdate.city;
    }
    if (!this.cusomerUpdate.district || this.cusomerUpdate.district == 0) {
      this.toastr.warning('Phải chọn Quận/Huyện', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    } else {
      body.district = this.cusomerUpdate.district;
    }
    if (this.cusomerUpdate.email) {
      body.email = this.cusomerUpdate.email;
    }

    for (const val in this.imagesFields) {
      console.log(`${val}: ${this.imagesFields[val]}`);
      this.cusomerUpdate['fields'][val] = this.imagesFields[val];
    }


    const fieldsData = {}
    for (const property in this.cusomerUpdate.fields) {
      if (this.typeField[property] === 'select' && this.listRequire.includes(property) && this.cusomerUpdate.fields[property] === '-1') {
        this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
        return;
      }
      if (this.typeField[property] === 'image') {
        fieldsData[property] = this.cusomerUpdate['fields'][property]
        if (this.listRequire.includes(property) && fieldsData[property].length === 0) {
          this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          return;
        }
      }
      if (this.typeField[property] === 'checkbox') {
        const arr = []
        for (const val in this.cusomerUpdate.fields[property]) {
          if (typeof this.cusomerUpdate.fields[property][val] === 'boolean') {
            if (this.cusomerUpdate.fields[property][val]) {
              const split = val.split('check')[1]
              arr.push(split)
            }
          } else {
            arr.push(this.cusomerUpdate.fields[property][val])
          }

        }
        fieldsData[property] = arr.join(',')

        if (this.listRequire.includes(property) && !fieldsData[property]) {
          this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          return;

        }
      } else if (this.typeField[property] === 'date') {
        console.log('this.cusomerUpdate.fields[property]', this.cusomerUpdate.fields[property])
        if (this.cusomerUpdate.fields[property]) {
          let dataDate = this.cusomerUpdate.fields[property]
          if (typeof this.cusomerUpdate.fields[property] === 'object') {
            dataDate = moment(this.cusomerUpdate.fields[property]).format('DD/MM/YYYY')
          }
          const date = dataDate.split('/')
          const dateTime = new Date(`${date[1]} ${date[0]} ${date[2]}`)
          fieldsData[property] = new Date(dateTime.getTime() - (dateTime.getTimezoneOffset() * 60000)).toISOString();
        }
        if (this.listRequire.includes(property) && !fieldsData[property]) {
          this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          return;

        }
      } else {

        fieldsData[property] = this.cusomerUpdate.fields[property]

        if (this.listRequire.includes(property) && !fieldsData[property]) {
          this.toastr.warning(`${this.typeName[property]} không được để trống`, '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          return;
        }
      }

    }

    body.fields = fieldsData
    // console.log('body', body)
    // console.log(this.cusomerUpdate);
    // return


    if (body.name && body.phone && body.city && body.district) {
      this.service.getUserByPhone(body.phone).subscribe((res) => {
        if (!res.error) {
          if (res.data.customer) {
            if (res.data.customer.id === this.item_detail.id) {
              this.service
                .updateById(this.item_detail.id, body)
                .toPromise()
                .then((res) => {
                  if (!res.error) {
                    this.toastr.success('Cập nhật thông tin thành công', '', {
                      timeOut: 4000,
                      positionClass: 'toast-bottom-right',
                    });
                    this.modalRef.hide();
                  } else {
                    this.toastr.error(res.message, '', {
                      timeOut: 4000,
                      positionClass: 'toast-bottom-right',
                    });
                  }
                })
                .catch((err) => {
                  this.toastr.error(err.message, '', {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right',
                  });
                });
            } else {
              this.toastr.warning(
                'Số điện thoại đã được sử dụng bởi người khác, vui lòng nhập lại số khác',
                '',
                {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                }
              );
            }
          } else {
            this.service
              .updateById(this.item_detail.id, body)
              .toPromise()
              .then((res) => {
                if (!res.error) {
                  this.toastr.success('Cập nhật thông tin thành công', '', {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right',
                  });
                  this.modalRef.hide();
                } else {
                  this.toastr.error(res.message, '', {
                    timeOut: 4000,
                    positionClass: 'toast-bottom-right',
                  });
                }
              })
              .catch((err) => {
                this.toastr.error(err.message, '', {
                  timeOut: 4000,
                  positionClass: 'toast-bottom-right',
                });
              });
          }
        }
      });
    }
  }

  downloadExcel() {
    const modelQuery = <any>{};
    if (this.model.name) {
      modelQuery.name = this.model.name;
    }
    if (this.model.phone) {
      modelQuery.phone = this.model.phone;
    }
    if (this.model.email) {
      modelQuery.email = this.model.email;
    }
    const status = $('#status option:selected').val();
    if (status != '') {
      modelQuery.status = status;
    }
    const city = $('#province option:selected').val();
    if (city != '') {
      modelQuery.city = parseInt(city);
    }
    const district = $('#district option:selected').val();
    if (district != '') {
      modelQuery.district = parseInt(district);
    }
    modelQuery.deleted = 0;
    let url = environment.api_evs + '/g_customers/excel?';

    if (modelQuery.name) {
      url += 'name=' + modelQuery.name;
    }
    if (modelQuery.phone) {
      url += '&phone=' + modelQuery.phone;
    }
    if (modelQuery.email) {
      url += '&email=' + modelQuery.email;
    }
    if (modelQuery.status) {
      url += '&status=' + modelQuery.status;
    }
    if (modelQuery.city) {
      url += '&city=' + modelQuery.city;
    }
    if (modelQuery.district) {
      url += '&district=' + modelQuery.district;
    }
    if (modelQuery.deleted) {
      url += '&deleted=' + 0;
    }
    url += '&sort_by=created_at:' + this.isSorting;
    if (localStorage.getItem('Access-Token')) {
      url += '&Access_Token=' + localStorage.getItem('Access-Token');
    }
    location.href = url;
  }

  openModal(template: TemplateRef<any>) {
    this.loadDataGift();
    this.modalRef2 = this.modalService.show(template);
  }

  loadDataGift(request: any = {}, sort: any = {}) {
    this.gifts = [];
    request.offset =
      this.page_size * (this.currentPage2 <= 0 ? 0 : this.currentPage2 - 1);
    request.limit = this.page_size;
    if (Object.keys(sort).length == 2) {
      request['sort_by'] = sort.field + ':' + sort.typeSort;
    }
    this.promotionService
      .listGift(request)
      .toPromise()
      .then(
        (res) => {
          if (res.status == 200) {
            this.gifts = res.data.list;

            for (let i = 0; i < this.gifts.length; i++) {
              this.gifts[i].image = this.imageService.readSrcImage(
                this.gifts[i].image,
                'thumb_medium'
              );
            }
            this.totalItem2 = res.data.total;
            const pageString = (this.totalItem2 / this.page_size).toString();
            const pageSplit = pageString.split('.');
            let last: any;
            let totalpage = parseInt(pageSplit[0]);
            if (pageSplit.length > 1) {
              last = pageSplit[1];
              if (parseInt(last) > 0) {
                totalpage++;
              }
            }
            this.totalPage2 = totalpage;
          } else {
            this.gifts = [];
          }
        },
        (err) => {
          this.gifts = [];
        }
      );
  }

  exchange(customer, gift) {
    this.promotionService
      .exchangeGift({ customer_id: customer.id, gift_id: gift.id })
      .subscribe((res) => {
        if (!res.error && res.status == 200) {
          this.toastr.success('Đổi quà thành công', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          this.modalRef2.hide();
        } else {
          this.toastr.error('Tạo mới không thành công', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          this.modalRef2.hide();
        }
      });
  }

  setPage2(page: number) {
    if (page <= this.totalPage2) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage2) {
        this.currentPage2 = page;
        this.loadDataGift();
      }
    } else {
      page = this.totalPage2;
      $('#inputPage2').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page <= this.totalPage2) {
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage2) {
          this.currentPage2 = page;
          this.loadDataGift();
        }
      }
    }
  }

  goPage3(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage2(toPage);
    }
  }

  _keyPress2(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }


  loadData(request: any = {}, sort) {
    this.dataCustomer = [];
    this.item_detail = undefined;
    this.loading_data = true;
    if (_.isEmpty(request)) {
      request = this.current_filter;
    }
    request.offset =
      this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    request.desc = 'id';
    request.deleted = 0;
    delete request.desc;
    delete request.asc;
    request.sort_by = 'id:' + sort;
    if (this.static_stamp_id) {
      request.static_stamp_id = this.static_stamp_id;
    }

    console.log(request);

    this.service
      .ListCustomer(request)
      .toPromise()
      .then(
        (res) => {
          //console.log(res.data.store)
          this.loading_data = false;
          if (res.status == 200 && res.error == false) {
            if (res.data.count) {
              this.totalItem.count = res.data.count.count;
            }
            if (res.data.count_customer) {
              this.totalItem.count_customer = res.data.count_customer.count;
            }
            if (res.data.count_not_yet) {
              this.totalItem.count_not_yet = res.data.count_not_yet.count;
            }
            if (res.data.count_doing) {
              this.totalItem.count_doing = res.data.count_doing.count;
            }
            if (res.data.count_have_been) {
              this.totalItem.count_have_been = res.data.count_have_been.count;
            }

            const pageString = (this.totalItem.count / this.page_size).toString();
            const pageSplit = pageString.split('.');
            let last: any;
            let totalpage = parseInt(pageSplit[0]);
            if (pageSplit.length > 1) {
              last = pageSplit[1];
              if (parseInt(last) > 0) {
                totalpage++;
              }
            }
            this.totalPage = totalpage;
            $('#tableCustomer').DataTable().destroy();
            this.totalRow = Object.keys(res.data).length ? res.data.total : 0;
            if (res.data.customers) {
              this.dataCustomer = res.data.customers;
              if (this.dataCustomer.length > 0) {
                this.viewDetail(
                  this.item_active,
                  this.dataCustomer[this.item_active]
                );
              }
            }
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: res.status + ' : ' + res.message,
            };
            this.dataCustomer = [];
            $('html, body').animate({ scrollTop: 0 }, 'slow');
          }
        },
        (err) => {
          this.message = {
            content: 'Load data: ' + err.message,
            class: 'alert dark alert-danger',
          };
          this.dataCustomer = [];
          // this.genDataTable();
          $('html, body').animate({ scrollTop: 0 }, 'slow');
        }
      );
  }

  viewDetail(i: any, detail: any) {
    this.guaranteeCurentpage = 1;
    this.historyOfcareCurentpage = 1;
    this.pageIndexStampVerify = 1;
    if (this.isUpdate == true) {
      this.toastr.info('Thao tác cập nhật khách hàng đã bị hủy', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }
    this.isUpdate = false;
    this.item_active = i;

    // let request = {};
    //request['offset'] = this.guaranteePage_size * (this.guaranteeCurentpage <= 0 ? 0 : this.guaranteeCurentpage - 1);
    //request['limit'] = this.guaranteePage_size;
    //request['desc'] = 'created_time';
    this.service.getDetailById(detail.id).subscribe((data) => {
      //console.log(data.data.logs)
      this.item_detail = data.data.customer;
      this.itemStatus = this.item_detail.status;
      if (this.item_detail.static_stamp_id) {
        this.loadStaticStamp(this.item_detail.static_stamp_id);
      }
      this.loadGuarantee();
      this.loadHistoryOfCare();
      this.listStampVerify();
    });
  }

  /**[27/10/2022]-Tuanba: Export and list **/

  convertServiceToText(service: string) {
    const arr_services: Array<{ code: number; name: string }> = [];
    if (service.indexOf(this.code_chonggia.toString()) != -1) {
      arr_services.push({ code: this.code_chonggia, name: this.translate.instant('CHONG_GIA') });
    }
    if (service.indexOf(this.code_baohanh.toString()) != -1) {
      arr_services.push({ code: this.code_baohanh, name: this.translate.instant('BAO_HANH') });
    }
    if (service.indexOf(this.code_tranhang.toString()) != -1) {
      arr_services.push({ code: this.code_tranhang, name: this.translate.instant('TRAN_HANG') });
    }
    if (service.indexOf(this.code_dinhdanh.toString()) != -1) {
      arr_services.push({ code: this.code_dinhdanh, name: this.translate.instant('DINH_DANH') });
    }
    return arr_services;
  }

  formatSerialNew(number, prefix: string = '') {
    let format_serial = 'không xác định';
    if (number) {
      const prefix2 = prefix ? prefix + '-' : '';
      number = number.toString();
      if (number.length > 6) {
        format_serial = prefix2 + number;
      } else {
        const pad = '000000';
        format_serial = prefix2 + pad.substring(0, 6 - number.length) + number;
      }
    }
    return format_serial;
  }

  public totalPageStampVerify: any;

  listStampVerify() {
    const customer_id = this.item_detail.id;
    const body = {
      page: this.pageIndexStampVerify,
      pageSize: this.pageSizeStampVerify
    }
    this.service.getListVerifyCustomer(customer_id, body).subscribe((res) => {
      if (res.code === 1 && res.data.items) {
        this.totalStampVerify = res.data.pagination.totalElements
        this.totalPageStampVerify = res.data.pagination.totalPages
        const data: any = []
        for (const item of res.data.items) {
          const obj = {
            prefix: this.formatSerialNew(item.number, item.prefix),
            number: item.number,
            product_name: item.product_name,
            product_image: item.product_image,
            services: item.services,
            created_at: item.created_at,
            arr_services: this.convertServiceToText(item.services),
          }
          data.push(obj);
        }
        this.dataStampVerify = data;
        console.log('this.dataStampVerify', this.dataStampVerify)
      }
    }, (error) => {
      this.toastr.error(error.message, 'Thất bại', {
        positionClass: 'toastr-bottom-right', timeOut: 3000
      })
    })
  }

  prePageListStampVerify() {
    if (this.pageIndexStampVerify > 1) {
      this.pageIndexStampVerify = this.pageIndexStampVerify - 1;
      this.listStampVerify();
    }

  }

  lastPageListStampVerify() {
    console.log(this.pageIndexStampVerify, this.pageSizeStampVerify, this.totalStampVerify)
    if (this.pageIndexStampVerify * this.pageSizeStampVerify < this.totalStampVerify) {
      console.log(123123123)
      this.pageIndexStampVerify = this.pageIndexStampVerify + 1;
      this.listStampVerify()
    } else {
      console.log(1231723123)
    }
  }

  inputPageListStampVerify(event) {
    let page = parseInt(event.target.value);
    if (page > this.totalPageStampVerify) {
      page = this.totalPageStampVerify;
      $('#inputPage3').val(page);
      this.pageIndexStampVerify = this.totalPageStampVerify;
      this.toastr.warning(
        'Số trang khách hàng tối đa hiện tại là ' + page,
        '',
        {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        }
      );
      return;
    } else {
      if (page % 1 === 0 && page > 0 && page !== this.pageIndexStampVerify) {
        this.pageIndexStampVerify = page;
        this.listStampVerify();
      }
    }
  }

  getListField() {
    this.evsStampService.getFieldGuaranteeCustomes().subscribe((res) => {
      if (res.data.length > 0) {
        // $('.stampBoxStampAlertAdd').css('opacity', '1');
        const arr = []
        res.data.map((val) => {
          if (val.status == 1) {
            arr.push(val)
          }
        })
        this.fieldExportCustomer = arr;
        console.log('airfields', this.fieldExportCustomer)
      }
    })
  }

  openModalExport(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
    this.getListField();
    $('#exportCustomer').select2({
      placeholder: this.translate.instant('CHON_THEM_THONG_TIN'),
    });
  }

  // tslint:disable-next-line:member-ordering
  exportCustomer() {
    this.messageExport = '';
    $('.stampBoxStampAlertAdd').css('opacity', '0');
    const modelQuery = <any>{};
    if (this.model.name) {
      modelQuery.name = this.model.name;
    }
    if (this.model.phone) {
      modelQuery.phone = this.model.phone;
    }
    if (this.model.email) {
      modelQuery.email = this.model.email;
    }
    const status = $('#status option:selected').val();
    if (status != '') {
      console.log('asdfabanm cbjasd')
      if (status == 'NotYet') {
        modelQuery.status = 0;
      } else if (status == 'Doing') {
        modelQuery.status = 1;
      } else if (status == 'HaveBeen') {
        modelQuery.status = 2;
      }
    }
    const city = $('#province option:selected').val();
    if (city != '') {
      modelQuery.province_id = parseInt(city);
    }
    const district = $('#district option:selected').val();
    if (district != '') {
      modelQuery.district_id = parseInt(district);
    }
    const created_time_val = $('#created_time').val();
    if (created_time_val) {
      const listDate = created_time_val.toString().split(' - ');
      if (listDate.length > 1) {
        modelQuery.from_create = moment(listDate[0], 'DD/MM/YYYY').format('YYYY-MM-DD');
        modelQuery.to_create = moment(listDate[1], 'DD/MM/YYYY').format('YYYY-MM-DD');
      }
    }
    const care_time = $('#care_time').val();
    console.log('created_time_val', created_time_val, care_time)
    if (care_time) {
      const listDate = care_time.toString().split(' - ');
      if (listDate.length > 1) {
        modelQuery.from_time_of_care = moment(listDate[0], 'DD/MM/YYYY').format('YYYY-MM-DD');
        modelQuery.to_time_of_care = moment(listDate[1], 'DD/MM/YYYY').format('YYYY-MM-DD');
      }
    }
    console.log('modalQueryt', modelQuery);
    const value = $('#exportCustomer').select2('val');
    console.log('value', value)
    const body = {
      history_care: null,
      stamp_verify: null,
      fields: ''
    }
    // const params = modelQuery
    if (value != null) {
      const history_care_value = value.filter(function (val) {
        return val == 'history_care';
      });
      const stamp_verify_value = value.filter(function (val) {
        return val == 'stamp_verify';
      });
      const fields_value = value.filter(function (val) {
        if (val !== 'history_care' && val !== 'stamp_verify') {
          return val;
        }
      });
      body.history_care = history_care_value.length > 0 ? 1 : 0;
      body.stamp_verify = stamp_verify_value.length > 0 ? 1 : 0;
      body.fields = fields_value.length > 0 ? fields_value.toString() : '';
      console.log('body', body)
    } else {
      body.history_care = 0;
      body.stamp_verify = 0;
      body.fields = '';
    }
    const reqBody = {
      exportTypeEnum: 'CUSTOMER',
      fields: { ...body, ...modelQuery }
    }
    this.exportService.exportReport(reqBody).subscribe((res) => {
      if (res.code == 1) {
        this.messageExport = this.translate.instant('HE_THONG_DANG_XU_LY');
        $('.stampBoxStampAlertAdd').css('opacity', '1');
        setTimeout(() => {
          $('.stampBoxStampAlertAdd').css('opacity', '0');
        }, 5000);
      } else {
        $('.stampBoxStampAlertAdd').css('opacity', '0');
        this.toastr.error(res.message, this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        })
      }
    }, (error) => {
      this.toastr.error(error.message, this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      })
    });
    this.modalRef.hide();
  }
  keyPressEvent(event: KeyboardEvent) {
    const nonNumericChars = /[^0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (nonNumericChars.test(inputChar)) {
      console.log('Chỉ nhập số.');
      event.preventDefault();
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/customer/list/list.component.ts